var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"empty-data"},[_c('div',{staticClass:"empty-data__container"},[_c('h3',{staticClass:"empty-data__title"},[_vm._v(_vm._s(_vm.title))]),_c('SmButton',{staticClass:"empty-data__btn",attrs:{"icon":"plus","onClick":function () { return this$1.$router.push('/appointment'); }}},[_vm._v(" Записаться ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }